import titleize from 'underscore.string/titleize';

angular
  .module 'filters'
  .filter 'titleize', ->
    (data) ->
      titleize(data)
